import React, { ReactElement } from 'react'
import QuestionIcon from '../../assets/images/QuestionIcon'
import Tooltip from '../Tooltip'

function TooltipWrapper({
  children,
  title,
  textPosition,
  className = 'mb5 mb0sm textPrimary',
  titleClassName = 'linkDefault',
}: {
  children: ReactElement
  title?: string | ReactElement
  textPosition?: string
  className?: string
  titleClassName?: string
}): ReactElement {
  return (
    <div className={`${className} ${textPosition || 'textRight'}`}>
      <Tooltip
        size="tooltipContainerSmall"
        trigger="click"
        tooltip={children}
        placement="bottom"
      >
        <div className="fontSizeSm dInlineFlex alignItemsCenter">
          {title && (
            <span className={`hidden-on-mobile pointer ${titleClassName}`}>
              {title}
            </span>
          )}
          <div className="ml05 lh0">
            <QuestionIcon />
          </div>
        </div>
      </Tooltip>
    </div>
  )
}

export default TooltipWrapper
